<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <Form
        ref="searchForm"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
        :model="listParams"
      >
        <Row>
          <FormItem label="" prop="classroomName">
            <Input
              v-model="listParams.classroomName"
              clearable
              placeholder="请输入课程班级名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :cache-year-terms="initYear"
              @on-init="termChange"
            ></CascaderYearTerms>
          </FormItem>
          <!-- <FormItem label="" prop="teacherName">
            <Input
              v-model="listParams.teacherName"
              clearable
              placeholder="请输入教师"
              class="search-input-430"
            ></Input>
          </FormItem> -->
          <FormItem label="" prop="signPersonId">
            <Select
              v-model="listParams.signPersonId"
              clearable
              filterable
              placeholder="教师姓名"
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in teacherList"
                :key="index"
                :value="item.teacherId"
              >{{ item.teacherName }}</Option>
            </Select>
          </FormItem>
          <FormItem label="" prop="productName">
            <Input
              v-model="listParams.productName"
              clearable
              placeholder="请输入课程商品名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem label="" prop="classType">
            <Select
              v-model="listParams.classType"
              clearable
              placeholder="请选择课程分类"
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in trainingTypes"
                :key="item.value"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="" prop="yearMonth">
            <Select
              v-model="listParams.yearMonth"
              placeholder="请选择月份"
              clearable
              class="search-select-430"
            >
              <Option
                v-for="(item) in yearMonthsList"
                :key="item"
                :value="item"
              >{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem v-if="theUserIdentity !== 'org'" prop="orgId" label="">
            <ChooseApply
              ref="chooseApplyRef"
              org-type=""
              @on-change="handleOnApplyChange"
            ></ChooseApply>
          </FormItem>
          <FormItem v-else prop="orgId" label="">
            {{ userInfo.orgName }}
          </FormItem>
          <Button
            type="primary"
            :disabled="!schoolId"
            @click="handleSearch"
          >查询</Button>
          <Button
            class="search-430"
            :disabled="!schoolId"
            @click="handleReset"
          >重置</Button>
        </Row>
      </Form>
    </div>
    <div class="table-title-special-430 flex justify-content_end">
      <Button type="primary" @click="handleExport">导出Excel</Button>
    </div>
    <div class="table">
      <Table
        ref="selection"
        border
        :max-height="tableHeight - 40"
        :columns="collectColumns"
        :data="collectData"
        :loading="tableLoading"
      >
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template slot="classroomName" slot-scope="{ row }">
          <TablePoptip :content="row.classroomName"> </TablePoptip>
        </template>
        <template slot="productName" slot-scope="{ row }">
          <TablePoptip :content="row.productName"> </TablePoptip>
        </template>
        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>
        <template slot="timeDesc" slot-scope="{ row }">
          <TablePoptip :content="row.timeDesc"> </TablePoptip>
        </template>

        <template slot="action" slot-scope="{ row, index }">
          <span
            class="click-btn-430"
            @click="handleOpenDetails(row)"
          >明细</span>
          <span
            class="click-btn-430"
            @click="handleOpenCollect(row)"
          >查看考勤汇总(按月)</span>
        </template>
      </Table>
      <div class="page-wrap">
        <Page
          :total="pageInfo.total"
          show-total
          show-elevator
          show-sizer
          :page-size-opts="pageSizeOpts"
          :current="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          @on-change="handlePageChange"
          @on-page-size-change="handleSizeChange"
        ></Page>
      </div>
    </div>
    <!-- 下载的进度弹窗 -->
    <Modal
      v-model="percentModalShow"
      title="正在导出"
      :mask-closable="false"
      @on-cancel="handleCancelDownLoad"
    >
      <Progress :percent="downLoadPersent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间，请不要关闭当前页面！
      <div slot="footer">
        <Button @click="handleCancelDownLoad">取消</Button>
      </div>
    </Modal>
    <TeacherAttendanceDetailsDrawer ref="detailsDrawer"></TeacherAttendanceDetailsDrawer>
    <TeacherCollectDrawer ref="teacherCollectDrawer"></TeacherCollectDrawer>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';
import TeacherAttendanceDetailsDrawer from './components/TeacherAttendanceDetailsDrawer';
import TeacherCollectDrawer from './components/TeacherCollectDrawer';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { tableColumnsWidth, key, slot, renderFn } from '@/assets/js/resetTableStyle';
import eduCenterApi from '@/request/eduCenter';
import { getMonthBetween } from '@/utils/moment.js';
import axios from 'axios';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
export default {
  components: {
    CascaderYearTerms,
    ChooseApply,
    TeacherAttendanceDetailsDrawer,
    TeacherCollectDrawer
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }, // 请假列表分页信息
      pageSizeOpts: [10, 20, 50, 100],
      schoolId: '',
      trainingTypes: [{
        value: '1',
        label: '素质课'
      }, {
        value: '2',
        label: '基础托管'
      }],
      initYear: [],
      listParams: {
        yearCode: '',
        termCode: 0,
        teacherName: '',
        classroomName: '',
        productName: '',
        classType: '',
        yearMonth: '',
        orgId: ''
      },
      yearMonthsList: [],
      collectColumns: [
        slot('学校', 'schoolName', tableColumnsWidth.type5, {
          fixed: 'left'
        }),
        key('教师姓名', 'teacherName', tableColumnsWidth.type8, {
          fixed: 'left'
        }),
        key('学期', 'termName', tableColumnsWidth.type4),
        key('班级ID', 'classroomId', tableColumnsWidth.type4),
        slot('课程班级名称', 'classroomName', tableColumnsWidth.type6),
        slot('课程商品名称', 'productName', tableColumnsWidth.type6),
        key('商品分类', 'courseTypeName', tableColumnsWidth.type4),
        slot('提供方', 'orgName', tableColumnsWidth.type6),
        slot('上课时间', 'timeDesc', tableColumnsWidth.type6),
        key('任教课时', 'classroomTotal', tableColumnsWidth.type3, {
          renderHeader: (h, params) => {
            return h(
              'Tooltip',
              { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
              [
                h('span', [
                  h('span', '任教课时'), // 列名
                  h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
                ]),
                h(
                  'span',
                  {
                    slot: 'content'
                  },
                  '任教课时 = 教师在该班级被设置的任教上课节次数'
                ) // 提示内容
              ]
            );
          }
        }),
        key('已签到', 'signSum', tableColumnsWidth.type2),
        key('未签到', 'notSignedSum', tableColumnsWidth.type2),
        key('请假', 'leaveSum', tableColumnsWidth.type2),
        slot('操作', 'action', tableColumnsWidth.type5, { fixed: 'right' })
      ],
      tableLoading: false,
      collectData: [],
      seachNum: 0,
      percentModalShow: false,
      downLoadPersent: 0,
      source: null,
      percentInterVal: null,
      searchData: {},
      teacherList: []
    };
  },
  computed: { ...mapState(['userInfo', 'theUserIdentity', 'schoolIdForState']) },
  mounted() {
    this.init();
    this.$eventHub.$on('changeSchool', id => {
      this.handleChangeSchool(id);
    });
  },
  destroyed() {
    this.$eventHub.$off('changeSchool');
  },
  methods: {
    handleOpenDetails(row) {
      const { signPersonId, classroomName } = row;
      this.$nextTick(() => {
        this.$refs.detailsDrawer.openDrawer(this.schoolId, { teaId: signPersonId, classroomName, yearCode: this.listParams.yearCode, termCode: this.listParams.termCode });
      });
    },
    handleOpenCollect(row) {
      const { signPersonId, classroomName } = row;
      const params = { teaId: signPersonId, classroomName, yearCode: this.listParams.yearCode, termCode: this.listParams.termCode };
      if (this.listParams.yearMonth) {
        params.yearMonth = this.listParams.yearMonth;
      }
      this.$nextTick(() => {
        this.$refs.teacherCollectDrawer.openDrawer(this.schoolId, params);
      });
    },
    init() {
      if (this.theUserIdentity === 'school') {
        this.schoolId = this.userInfo.orgId;
      } else {
        this.schoolId = this.schoolIdForState ? this.schoolIdForState : '';
        if (this.schoolId) {
          this.handleChangeSchool(this.schoolId);
        }
      }
      this.getTeacherlist();
    },
    // 教师姓名下拉列表
    async getTeacherlist(teacherName = '') {
      const params = {
        schoolId: this.schoolId,
        teacherName: teacherName
      };
      const res = await this.$http.getQuerySchoolOrgTeacher(params);
      if (res.status === 200) {
        this.teacherList = res.message;
      }
    },
    // 切换学校
    async handleChangeSchool(id) {
      this.schoolId = id;
      this.listParams.yearCode && this.listParams.termCode ? this.handleSearch() : '';
    },
    async getTeacherSignCollect() {
      const params = {
        schoolId: this.schoolId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        ...this.searchData
      };

      this.tableLoading = true;
      try {
        const res = await eduCenterApi.getTeacherSignCollectPageApi(params);
        if (res.status === 200) {
          this.collectData = res.message.list.map(item => {
            return item;
          });
          this.pageInfo.total = +res.message.total;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.tableLoading = false;
      }
    },
    termChange(v) {
      this.listParams.yearCode = v[0];
      this.listParams.termCode = v[1];
      setTimeout(() => {
        const sysYt = this.$refs.cascaderYearTerms.getObjResult();
        const sysYTBeginTime = sysYt ? sysYt.beginTime : '';
        const sysYTEndTime = sysYt ? sysYt.endTime : '';
        if (sysYTBeginTime && sysYTEndTime) {
          this.yearMonthsList = getMonthBetween(sysYTBeginTime, sysYTEndTime);
          this.listParams.yearMonth = '';
        }
        console.log(this.yearMonthsList);
        if (this.seachNum === 0) {
          this.handleSearch();
        }
      }, 400);
      if (this.seachNum === 0) {
        this.handleSearch();
      }
    },
    handleOnApplyChange(val) {
      this.listParams.orgId = val.orgId;
    },
    handleSearch() {
      this.seachNum++;
      this.searchData = {};
      Object.keys(this.listParams).forEach(item => {
        if (this.listParams[item]) {
          this.searchData[item] = this.listParams[item];
        }
      });
      this.getTeacherSignCollect();
    },
    handleReset() {
      // 置空表单项
      this.$refs['searchForm'].resetFields();
      const yearTerms = this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.handleDefault();
      console.log(yearTerms, '拿到的----重置学期----');
      if (yearTerms && yearTerms.length) {
        this.listParams.yearCode = yearTerms[0];
        this.listParams.termCode = yearTerms[1];
      }
      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();
      this.seachNum = 0;
      this.init();
    },
    handlePageChange(v) {
      this.pageInfo.pageNum = v;
      this.handleSearch();
    },
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.handleSearch();
    },
    handleExport() {
      this.handleExSubmit();
    },
    // 取消导出
    handleCancelDownLoad() {
      this.percentModalShow = false;
      if (this.source) {
        this.source.cancel('取消导出'); // 这里传递的什么字符串，在上面的rej.message值就是什么
        // this.uploadPersent = 0;
        // this.canUploadFile = true;
        // this.modalShow = false;
        // this.uploadType === '';
      }
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.downLoadPersent += 20;
      if (this.downLoadPersent >= 80) {
        clearInterval(this.percentInterVal);
      }
    },
    percentShow() {
      this.downLoadPersent = 0;
      this.percentInterVal = setInterval(this.percentShowFun, 500);
    },
    // 导出-确定
    async handleExSubmit() {
      const params = {
        pageNum: 1,
        pageSize: this.pageInfo.total,
        schoolId: this.schoolId
      };
      const paramsData = Object.assign({}, this.searchData, params);
      this.percentModalShow = true;
      this.percentShow();
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      const onDownloadProgress = progressEvent => {
        if (progressEvent.lengthComputable) {
          const val = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);
          this.downLoadPersent = parseInt(val);
        }
      };
      const res = await eduCenterApi.getTeacherSignCollectExportApi(
        paramsData,
        this.source.token,
        onDownloadProgress
      );
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 100;
            setTimeout(() => {
              this.percentModalShow = false;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 100;
            setTimeout(() => {
              this.percentModalShow = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.percentModalShow = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
